/** HTTP methods that require a CSRF token header on mutating requests. */
export const CSRF_METHOD = Object.freeze({
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
})

export const CSRF_METHODS = Object.freeze(Object.values(CSRF_METHOD))
